import { put } from '..';

const reinviteUser = (email: string) => put('users/reinvite', { email });

export default reinviteUser;
